module.exports = __webpack_public_path__ + "static/media/card_bg_3.1151159e.png";